export default "__VITE_ASSET__CaMQ12wj__"